<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Invoice Number</th>
                    <th class="text-right">Invoice Amount</th>
                    <th>Party Name</th>
                    <th>Template Name</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td> {{ item.date }}</td>
                    <td> 
                        {{ item.bill_number }}
                        <span v-if="item.sync_status === 'success'" class="ms-1" title="Synced Successfully">
                            <i class="fas fa-check-circle text-success"></i>
                        </span>
                        <span v-else-if="item.sync_status === 'failed'" class="ms-1" title="Sync Failed">
                            <i class="fas fa-times-circle text-danger"></i>
                        </span>
                        <span v-else-if="item.sync_status === 'pending'" class="ms-1" title="Sync Pending">
                            <i class="fas fa-clock text-warning"></i>
                        </span>
                        <button v-if="route_name === 'service-sales-invoice-edit' && (item.sync_status === 'failed' || item.sync_status === 'pending' || !item.sync_status)"
                                class="btn btn-sm ms-1 px-1 py-0"
                                title="Sync to Remote Server"
                                @click="syncRemote(item.id)">
                            <i class="fas fa-sync-alt"></i>
                        </button>
                    </td>
                    <td class="text-right"> {{ item.bill_amount }}</td>
                    <td> {{ item.party_name }}</td>
                    <td> {{ item.template_log ? item.template_log.title || '' : '' }}</td>
                    <td>
                        <div class="d-flex">
                            <button class="btn btn-primary btn-sm mx-2"
                                    @click="goToEdit(item.id)"
                                    style="cursor: pointer"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <div class="dropdown">
                              <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                                  <i class="fas fa-ellipsis-v"></i>
                              </button>
                              <ul class="dropdown-menu">
                                  <li>
                                      <a class="dropdown-item" href="#" @click.prevent="goToPrint(item.id, 1)">
                                          <i class="fas fa-print me-2"></i> Print Invoice
                                      </a>
                                  </li>
                                  <li>
                                      <a class="dropdown-item" href="#" @click.prevent="goToPrint(item.id, 2)">
                                          <i class="fas fa-print me-2"></i> Print Challan
                                      </a>
                                  </li>
                                  <li>
                                      <a class="dropdown-item" href="#" @click.prevent="goToWasaPrint(item.id)">
                                          <i class="fas fa-file-invoice me-2"></i> Wasa Bill Print
                                      </a>
                                  </li>
                                  <li>
                                      <a class="dropdown-item" href="#" @click.prevent="goToMushakPrint(item.id)">
                                          <i class="fas fa-print me-2"></i> Print Mushak 6.3
                                      </a>
                                  </li>
                                  <li>
                                      <a class="dropdown-item" href="#" @click.prevent="goToMushakPrintEN(item.id)">
                                          <i class="fas fa-print me-2"></i> Print Mushak 6.3(EN)
                                      </a>
                                  </li>
                              </ul>
                            </div>
                        </div>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<style scoped>
.btn-challan {
    background-color: #249024 !important;
}

.table-responsive {
    overflow: visible;
}

.dropdown-menu.show {
    z-index: 1055;
}
</style>

<script>
import { inject } from 'vue';
import figureFormatter from '@/services/utils/figureFormatter';
import handlePurchase from "@/services/modules/purchase";
import pdfPrinter from '@/services/utils/pdfPrinter';
import wasaBillPrinter from '@/services/utils/wasaBillPrinter';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import handleHospital from '@/services/modules/hospital'
import printMushak63 from '@/services/utils/pdf/mushakPdf'
import printMushak63En from '@/services/utils/pdf/mushakPdfEn'

export default {  
    name: 'PurchaseListTable',
    data() {
        return{
            companyInfo: {},
            invoice: {},
            barcodeQuery: '',
            barcode: '',
            user: {},
            qrcode: '',
            customizationPdfFields:[],
            invoiceNotes: []
        }
    },
    props: {
        purchase: Array,
        route_name: {
            type: String,
            default: 'purchase-bill-edit'
        },
    },
    setup() {
        const {commaFormat} = figureFormatter()
        const { fetchSalesBill, syncRemoteInvoice } = handlePurchase();
        const {fetchCompanyInfo, fetchActiveCustomizationField} = handleCompany();
        const { exportToPDF } = pdfPrinter();
        const { exportToPDFWasaBill } = wasaBillPrinter();
        const { fetchBarcode } = handleBarcode();
        const store = useStore();
        const { notesByType } = handleHospital()
        const { exportToPdfMushak } = printMushak63()
        const { exportToPdfMushakEn } = printMushak63En()
        const showError = inject('showError')
        const showSuccess = inject('showSuccess')

        return {
            commaFormat,
            fetchSalesBill,
            syncRemoteInvoice,
            exportToPDF,
            exportToPDFWasaBill,
            fetchCompanyInfo,
            fetchBarcode,
            store,
            notesByType,
            fetchActiveCustomizationField,
            exportToPdfMushak,
            exportToPdfMushakEn,
            showError,
            showSuccess
        }
    },
    mounted() {
         this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
            this.companyInfo = res.data;
         }).catch((error) => {
            console.log(error);
         });

         this.getInvoiceNotes();
         this.getActiveFiledCustomization();

         this.user = this.store.state.user.user
    },
    methods: {
        async getInvoiceNotes () {
            const companyQuery = `?company_id=${this.$route.params.companyId}&show_default_only=1`;
            await this.notesByType(companyQuery, "invoice_terms").then((res) => {
                if(! res.status) return;
                this.invoiceNotes = res.data.filter((item) => item.full_desc);
            })
        },
        async getActiveFiledCustomization () {
          const companyQuery = `?company_id=${this.$route.params.companyId}&customization_type=pdf&type=sale_invoice_pdf_list`;
          await this.fetchActiveCustomizationField(companyQuery).then((res) => {
            this.customizationPdfFields = res.data
          })
        },
        goToEdit(id) {
            let dynamicKeyName = (this.route_name === 'purchase-bill-edit') ? 'purchaseId' : 'salesId'
            let param = {
              companyId: this.$route.params.companyId,
              moduleId: this.$route.params.moduleId,
              menuId: this.$route.params.menuId,
              pageId: this.$route.params.pageId,
            }
            param[dynamicKeyName] = id;
            this.$router.push({
                name: this.route_name,
                params: param,
                query: this.$route.query
            })
        },
        goToPrint(id, btnFunc) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.fetchSalesBill(id, companyQuery).then( (res) =>{
                if( res ){
                    this.invoice = res.data;
                    let qrcodeData = JSON.stringify({
                        ref_no: this.invoice.bill_number,
                        ref_date: this.invoice.date,
                        created_by: this.invoice.created_by_name,
                        created_date_time: this.formatDate(new Date())
                    })
                    this.barcodeQuery = `?code=${this.invoice.bill_number}&qrcode=${qrcodeData}`;     
                }}).then (() => {
                    this.fetchBarcode(this.barcodeQuery).then( (res) => {
                    this.barcode = res.barcode;
                    this.qrcode = res.qrcode
                }).then( () => {
                    this.exportToPDF(this.companyInfo, this.invoice, this.barcode, this.qrcode, this.user.name, btnFunc, this.invoiceNotes, false, this.customizationPdfFields)
                })  
            }).catch( (err) => {
                console.log("Something went wrong");
            })
        },
        formatDate(date) {
            var formattedDate = date.toISOString().split('T')[0];
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var amOrPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;

            return this.formatToDdMmYy(formattedDate) + ' ' + formattedTime
        },
        formatToDdMmYy(date) {
            var dat = date.split('-');
            return `${dat[2]}-${dat[1]}-${dat[0]}`;
        },
        syncRemote(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.syncRemoteInvoice(id, companyQuery).then(res => {
                if (!res.status) {
                    return this.showError(res.message);
                }

                this.$emit('onSynced', id);
                this.showSuccess(res.message);
            }).catch(err => {
                console.error(err);
            });
        },
        goToWasaPrint(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.fetchSalesBill(id, companyQuery).then((res) => {
                if (!res) return;
                this.invoice = res.data;
                this.exportToPDFWasaBill(this.companyInfo, this.invoice, this.user.name);
            })
        },
        goToMushakPrint(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.fetchSalesBill(id, companyQuery).then((res) => {
                if (!res) return;
                this.invoice = res.data;
                this.exportToPdfMushak(this.companyInfo, this.invoice, this.user);
            })
        },
        goToMushakPrintEN(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.fetchSalesBill(id, companyQuery).then((res) => {
                if (!res) return;
                this.invoice = res.data;
                this.exportToPdfMushakEn(this.companyInfo, this.invoice, this.user);
            })
        }
    }
}
</script>
